import React, { useContext, useState } from "react";

type CoachingAppState = ReturnType<typeof useInitCoachingAppState>

export const CoachingAppContext = React.createContext<CoachingAppState>({} as CoachingAppState);
export const useCoachingAppContext = () => useContext(CoachingAppContext)

export const useInitCoachingAppState = () => {

  const return_val = {
  }

  return return_val;
};